export const verticalBanner = {
    mobile: {
        wrapper: {
            borderRadius: "0.8vw",            
            overflow: "hidden",
        },
        banner: {
            width: "100%"
        },
        dots: {             
            paddingLeft: "unset",
            marginTop: "-3vw" 
        }
    },
    desktop: {                               
        wrapper: {
            display: "flex",
            flexDirection: "column",
            gap: "3vw"
        },
        banner: {
            height: "50.41vw",
            borderRadius: "0.8vw"
        },
        sliderWrapper: {
            overflow: "hidden",
            borderRadius: "0.8vw",
            cursor: "pointer"
        },
        googleBanner: {
            display: "block",    
            height: "50.42vw"
        }
    }
}